<template>
  <Dialog
    :width="createRenderType == 'pc' ? '340px' : '320px'"
    :backgroundImage="null"
    background="rgba(255, 255, 255, 0.2)"
    titleAlign="center"
    title=""
    customClass="download-mine-audio-pay-dialog"
    :hideCloseBtn="false"
    :visible="renderData.visible"
    @close="closeDialog"
  >
    <div class="height-all download-mine-audio-pay flex-column">
      <div class="dmap-title tc">
        微信{{ shouldUseMobileLogic ? "" : "扫码" }}支付
        <span>{{ totalPrice }}元</span>
      </div>
      <div class="dmap-content">
        <div class="dmap-qr-code height-all" v-if="!shouldUseMobileLogic">
          <div
            class="dmap-qr-code-img"
            :style="{
              backgroundImage: `url(${qrCodeUrl})`,
              backgroundSize: '100% 100%',
            }"
          ></div>
        </div>
        <div v-if="shouldUseMobileLogic" class="dmap-items mobile-dmap-items">
          <div class="dmap-items-title tc">
            {{ $$t("create.read_before_paying") }}
          </div>
          <div class="dmap-items-terms tc pointer" @click="handleOpenService">
            {{ $$t("create.paid_service") }}
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  reactive,
  watch,
  onUnmounted,
  getCurrentInstance
} from "vue";
import { storeToRefs } from "pinia";
import QRCode from "qrcode";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import apiMine from "@/api/api/apiMine.js";
import { isMobileDevice } from "@/utils/tools";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import GlobalConfig, { ModuleOpenStateControl } from "@/config/config.js";
import message from "@/components/functionCallComponent/message/message.js";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t } = globalProperties?.$i18n
const props = defineProps({
  orderId: {
    type: Number,
    default: 0,
  },
  totalPrice: {
    type: Number,
    default: 0,
  },
  visible: {
    type: Boolean,
    default: false,
  },
  qrCode: {
    type: String,
    default: "",
  },
  paySuccess: {
    type: Function,
    default: null,
  },
  payFail: {
    type: Function,
    default: null,
  },
  remove: {
    type: Function,
    default: null,
  },
});

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const emits = defineEmits(["update:visible"]);
const renderData = reactive({
  visible: props.visible,
});
const qrCodeUrl = ref("");
let intervalId = null;

const closeDialog = () => {
  renderData.visible = false;
};

const getQrCodeUrl = () => {
  QRCode.toDataURL(props.qrCode)
    .then((url) => {
      qrCodeUrl.value = url;
      // PC端直接开始轮询支付结果
      intervalId = setInterval(getResult, 5000);
    })
    .catch((error) => {
      console.error("生成二维码失败：", error);
    });
};

// 监听visible变化
watch(
  () => props.visible,
  (val) => {
    renderData.visible = val;
  }
);

// 关闭对话框时清理
watch(
  () => renderData.visible,
  (val) => {
    if (!val) {
      intervalId && clearInterval(intervalId);
      props.remove?.();
      emits("update:visible", val);
    }
  }
);

// 监听二维码变化
watch(
  () => props.qrCode,
  () => {
    getQrCodeUrl();
  },
  { immediate: true }
);

// 监听渲染类型变化
watch(
  () => createRenderType.value,
  () => {
    props.remove?.();
    renderData.visible = false;
    emits("update:visible", false);
  }
);

const getResult = () => {
  apiMine
    .mineOrderDetail({
      order_id: props.orderId,
    })
    .then((res) => {
      if (res.code == 200) {
        const {
          data: { state },
        } = res;
        if (state == 4) {
          message.success({
            position: "top",
            content: "付款成功",
            duration: 2000,
          });
          clearInterval(intervalId);
          props.paySuccess?.();
          closeDialog();
        }
      }
    });
};

const handleOpenService = () => {
  window.open(window.location.origin + "/paid-service", "_blank");
};

onUnmounted(() => {
  intervalId && clearInterval(intervalId);
});
</script>
<style lang="scss">
.download-mine-audio-pay-dialog {
  .dialog-box {
    padding: 24px 0 0 0;
    border-radius: 13px;
    opacity: 1;
    backdrop-filter: blur(20px);
  }
  .dialog-close {
    top: 16px;
    right: 16px;
  }
  .dialog-header {
    font-family: HarmonyOS Sans SC;
    font-size: 18px;
    font-weight: normal;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
  }
  .content-top-margin {
    height: 7px;
  }
  .dmap-title {
    font-family: HarmonyOS Sans SC;
    font-size: 20px;
    font-weight: 700;
    line-height: 40px;
    color: #fff;
    span {
      color: #94adff;
    }
  }
  .dmap-content {
    margin: 28px auto 60px;
    width: 296px;
  }
  .dmap-qr-code {
    .dmap-qr-code-img {
      margin: 0 auto;
      width: 184px;
      height: 184px;
      border-radius: 8px;
    }
    .dmap-qr-code-text {
      margin-top: 12px;
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 20px;
      opacity: 0;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  .dmap-items {
    height: 184px;
    width: 184px;
    border-radius: 8px;
    border: 1px solid rgba(148, 173, 255, 0.3);
    margin: 0 auto;
    .dmap-items-title {
      padding-top: 28px;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 22px;
      color: #ffffff;
    }
    .dmap-items-terms {
      margin-top: 20px;
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 22px;
      color: #fff;
      opacity: 0.8;
      text-decoration: underline;
      &:hover {
        opacity: 0.75;
      }
    }
    .dmap-items-go-pay {
      margin: 20px auto 0 auto;
      width: 140px;
    }
  }
  .mobile-dmap-items {
    width: 200px;
    height: 200px;
  }
}
</style>
